import { getModuleContextMailboxInfo } from 'owa-module-context-mailboxinfo';
import {
    CalendarViewDocument,
    type CalendarViewQuery,
} from 'hybridspace-common/lib/graphql/__generated__/CalendarViewQuery.interface';
import { useManagedQueryWithError } from 'hybridspace-graphql/lib/utils/useManagedQueryWithError';
import { getISOString } from 'owa-datetime';

import type { OwaDate } from 'owa-datetime';
import type { QueryResult } from '@apollo/client';
import type { MailboxInfo } from 'owa-client-types';

export default function useCalendarView(
    startDate: OwaDate,
    endDate: OwaDate,
    skip = false,
    maxResults = 25
): QueryResult<
    CalendarViewQuery,
    {
        input: {
            dateRange: {
                start: string;
                end: string;
            };
            calendarEntryData: {
                calendarId: {
                    id: string;
                    mailboxInfo: MailboxInfo;
                };
            };
            maxResults: number;
        };
    }
> {
    const mailboxInfo = getModuleContextMailboxInfo();
    const smtpAddress = mailboxInfo?.mailboxSmtpAddress;
    return useManagedQueryWithError(CalendarViewDocument, {
        variables: {
            input: {
                dateRange: {
                    start: getISOString(startDate),
                    end: getISOString(endDate),
                },
                calendarEntryData: {
                    calendarId: {
                        id: 'HybridspaceCalendarView', // this var is not required on the server side, but it needs to be non-nullable
                        mailboxInfo:
                            // We should be passing a full mailboxInfo object here, but there's a disagreement between the GraphQL contract
                            // and what the backend will actually accept.
                            // https://outlookweb.visualstudio.com/Time%20and%20Places/_workitems/edit/376654
                            {
                                mailboxSmtpAddress: smtpAddress,
                                userIdentity: smtpAddress,
                            } as unknown as MailboxInfo,
                    },
                },
                maxResults,
            },
        },
        skip: skip || !smtpAddress,
        fetchPolicy: 'cache-and-network',
    });
}
